import { useState, useEffect } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import MDBadge from "components/MDBadge";
import MDInput from "components/MDInput";
import MDPopup from "components/MDPopup";
import MDAlert from "components/MDAlert";

import MDSelect from "components/MDSelect";

import { Link } from "react-router-dom";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

import PasswordPopPup from "./updatePassword"

import { useAuthContext } from "../../../hooks/useAuthContext";

import { httpGet, httpPut } from "../../../api";

import { jwtDecode } from "jwt-decode";

const ProfilePage = () => {
  const { user, dispatch } = useAuthContext();

  const [submitValidation, setSubmitValidation] = useState(false);

  const [email, setEmail] = useState(user.email);

  const [first_name, setFirstName] = useState(user.first_name);

  const [second_name, setSecondName] = useState(user.second_name);

  useEffect(() => {
    setSubmitValidation((!!email && !!first_name && !!second_name) && (email !== user.email || first_name !== user.first_name || second_name !== user.second_name));

  }, [email, first_name, second_name])

  const handleSubmit = () => {
    httpPut(process.env.REACT_APP_URL_BASE + "/user/info", {
      first_name,
      second_name,
      email
    }).then((response) => {
      if (response.status === 200) {
        return response.json();
      }else{
        alert("Something went wrong");

        console.log(response);
      }
    }).then((data) => {
      // save the new token
      localStorage.setItem("user", JSON.stringify(data));

      const new_user = {
          ...jwtDecode(data.token.toString()),
          token: data.token
      }

      setSubmitValidation(false);

      dispatch({ type: "LOGIN", payload: new_user });

      alert("Profile updated");
    });
  }

  const [openNote, setOpenNote] = useState(false);

  const handleCloseNote = () => {
    setOpenNote(false);
  }


  return ( 
    <>
    <DashboardLayout>
      <PasswordPopPup open={openNote} close={handleCloseNote} />
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="error"
                borderRadius="lg"
                coloredShadow="info"
                sx={{textAlign: "center"}}
              >
                <MDTypography variant="h3" color="white">
                  Edit Profile Info
                </MDTypography>
              </MDBox>
              <MDBox p={3} sx={{
                  display: "flex",
                  justifyContent:"center",
                  alignItems: "center",
                  flexDirection: 'column'}}>

                  <MDBox m={3} sx={{ width: "100%", height: "100%", display: "flex", justifyContent:"space-around" }}>
                    <MDBox sx={{width: "50%", display: "flex", textAlign: "center", justifyContent: "center", flexDirection: "column"}}>
                      <MDTypography variant="label">
                        Email :
                      </MDTypography>

                      <MDInput type="text" label="Email" defaultValue={user.email} onChange={(e) => setEmail(e.target.value)} />

                      <br />

                      <MDTypography variant="label">
                        First name :
                      </MDTypography>

                      <MDInput type="text" label="Username" defaultValue={user.first_name} onChange={(e) => setFirstName(e.target.value)} />

                      <br />

                      <MDTypography variant="label">
                        Second name :
                      </MDTypography>

                      <MDInput type="text" label="Username" defaultValue={user.second_name} onChange={(e) => setSecondName(e.target.value)} />

                      <br />

                      <div>
                        <MDButton variant="gradient" color="warning" onClick={(e) => {setOpenNote(true)}}>
                          Update Password
                        </MDButton>
                      </div>

                    </MDBox>
                  </MDBox>

                  <MDButton variant="gradient" color="success" disabled={!submitValidation} onClick={handleSubmit}>
                    Save
                  </MDButton>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
    </>

  )
}

export default ProfilePage